export default __webpack_public_path__ + "static/media/memo-up-down.7666c479.svg";